import { I18nProvider } from "@refinedev/core";
import i18n from "../i18n/config";

export const i18nProvider: I18nProvider = {
  translate: (key: string, options?: any) => {
    return i18n.t(key, options) as string;
  },
  changeLocale: (lang: string) => {
    return i18n.changeLanguage(lang);
  },
  getLocale: () => {
    return i18n.language;
  },
};
